import barba from "@barba/core";
import { gsap, Cubic, Sine } from "gsap";
import updateMetaData from "../functions/updateMetaData";
export default () => {
    barba.init({
        schema: {
            prefix: "data-custom",
            wrapper: "wrap",
        },
        preventRunning: true,
        transitions: [
            {
                sync: false,
                name: "opacity-transition",
                to: {
                    custom(data) {
                        // @ts-ignore
                        if (data.trigger.id && data.trigger.id === "404")
                            return false;
                        else
                            return true;
                    },
                },
                // @ts-ignore
                leave(data) {
                    data.current.container.style.zIndex = "1";
                    data.next.container.style.transform = `translateY(${data.current.container.clientHeight}px)`;
                    data.next.container.style.zIndex = "-1";
                },
                // @ts-ignore
                after(data) {
                    data.current.container.style.zIndex = "-1";
                    data.next.container.style.transform = `translateY(0px)`;
                    data.next.container.style.zIndex = "1";
                    const nextDocument = new DOMParser().parseFromString(data.next.html, "text/html");
                    updateMetaData(["description", "image", "url"], nextDocument);
                },
            },
            {
                sync: true,
                name: "galleryToSingle",
                to: {
                    custom: (data) => {
                        const trigger = data.trigger;
                        if (trigger === "back")
                            return false;
                        if (trigger === "forward")
                            return false;
                        if (trigger.dataset && trigger.dataset.transition)
                            return true;
                    },
                },
                // @ts-ignore
                leave(data) {
                    const trigger = data.trigger;
                    const image = trigger.querySelector("img");
                    const { top, left, height, width } = image.getBoundingClientRect();
                    const t1 = gsap.timeline();
                    return t1.fromTo(image, {
                        position: "fixed",
                        top: top,
                        left: left,
                        width: width,
                        height: height,
                        ease: Cubic.easeInOut,
                        objectFit: "cover",
                    }, {
                        top: top + 40,
                        scale: trigger.dataset.transition ? 1.1 : 1.1,
                        left: left,
                        ease: Sine.easeInOut,
                    });
                },
                // @ts-ignore
                enter(data) {
                    const targetImage = data.next.container.querySelector(".transition-target");
                    targetImage.classList.add("no-fade");
                    const nextContainer = data.next.container;
                    const currentContainer = data.current.container;
                    const trigger = data.trigger;
                    const image = trigger.children[0];
                    const t1 = gsap.timeline();
                    image.remove();
                    nextContainer.append(image);
                    return t1
                        .to(targetImage, {
                        opacity: 0,
                    })
                        .to(currentContainer, {
                        opacity: 0,
                        ease: Sine.easeInOut,
                    }, 0);
                },
                after(data) {
                    const targetImage = data.next.container.querySelector(".transition-target");
                    const image = data.next.container.querySelector(".will-transition");
                    const { top, left } = targetImage.getBoundingClientRect();
                    const t1 = gsap.timeline();
                    return t1
                        .to(image, {
                        position: "absolute",
                        top: (top - 200).toString() + "px",
                        left: left.toString() + "px",
                        scale: 1,
                        width: targetImage.clientWidth,
                        height: targetImage.clientHeight,
                        ease: Sine.easeInOut,
                    })
                        .to(targetImage, {
                        opacity: 1,
                        duration: 0,
                    })
                        .call(() => image.remove());
                },
            },
        ],
    });
};
